<template>
  <div>
    <p class="help-text">Click the box to choose photos (you can pick several at once). They upload straight
      away and appear on the Images tab.</p>
    <!--If location is just to make sure it only renders after the prop has loaded because we are using the prop id in action-->
    <el-upload v-if="location"
               :action="rootpath + '/api/locations/' + this.location._id + '/images/'"
               :headers="headers"
               name="locationImage"
               list-type="picture-card"
               :on-preview="handlePictureCardPreview"
               :before-remove="confirmRemove"
               :on-remove="handleRemove"
               :multiple="true"
               :show-file-list="true"
               :on-success="emitChange"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ['location'],
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        files: '',
        headers: {
          Authorization: localStorage.getItem('Authorization')
        },
        // Counter helps ensure we only emit once rather than over and over when each file is uploaded.
        counter: 0,

        rootpath: process.env.VUE_APP_ROOT_API
      };
    },
    methods: {
      // Removing an uploaded photo deletes it from the location, so check first.
      confirmRemove() {
        return this.$confirm('Delete this image from the location?', 'Delete image', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
      },

      handleRemove(file, fileList) {

        const fileID = file.response.createdImage._id;

        this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id }/images/${fileID}`,
          {
            headers: {
              Authorization: localStorage.getItem('Authorization')
            }
          })
          .then(result => {
            console.log(result);

            // Updates the images again for deletion.
            this.counter--;
            this.$emit('changed');

            this.$notify({
              title: 'Success',
              message: 'Image Removed.',
              type: 'success'
            });

          })
          .catch(err => {
            console.log(err);
          });


        console.log(file, fileList);
      },

      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      // This is used to prompt the location images component to reload.
      emitChange(response, file, fileList) {

        // Ensures only emitted once all have been uploaded
        this.counter++;
        if (this.counter == fileList.length) {
          console.log('should only be emitted once');
          this.$emit('changed');
        }


      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/locations/LocationImageUpload.vue